import { FormBox, FormBoxTitle, Input_, Slider_, Toggle_Stat } from 'monica-alexandria';
import styled from 'styled-components';

const OfferPreviewPaidSliderContent = styled.div`
    display: grid;
    gap: 1.2rem;
`;

const OfferPreviewPaymentSummary = styled.div`
    display: grid;
    gap: 0.6rem;

    div {
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 1rem;
    }
`;

const OfferPreviewPaymentToggle = styled(Toggle_Stat)`
    ${p => p.disabled ? `
        pointer-events: none;
        opacity: 0.65;
    ` : ''}
`;

const format_payment_amount = (amount = 0, currency = 'EUR') => {
    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency
    }).format(Number(amount || 0));
};

export default function Offer_Preview_Paid_Slider(props) {
    const isPartialPayment = props.registerPrepayment;
    const sliderTitle = props.fulfillRemainingPayment
        ? props.copy.fulfillPaymentTitle
        : props.copy.paidSliderTitle;
    const sliderAction = props.fulfillRemainingPayment
        ? props.copy.fulfillPaymentAction
        : isPartialPayment ? props.copy.partialSliderAction : props.copy.paidSliderAction;

    return (
        <Slider_
            title={sliderTitle}
            text={props.isSaving ? props.copy.processing : sliderAction}
            disabled={props.isSaving || (isPartialPayment && !props.partialAmountIsValid)}
            onClose={props.onClose}
            onClick={props.onConfirm}
        >
            <OfferPreviewPaidSliderContent>
                {props.fulfillRemainingPayment ? (
                    <FormBox>
                        <FormBoxTitle>
                            <h4>{props.copy.paymentRemaining}</h4>
                        </FormBoxTitle>
                        <OfferPreviewPaymentSummary>
                            <div>
                                <p>{props.copy.paymentRemaining}</p>
                                <h5>{format_payment_amount(props.paymentRemaining, props.currency)}</h5>
                            </div>
                            <p>{props.copy.fulfillmentGoalIncluded}</p>
                        </OfferPreviewPaymentSummary>
                    </FormBox>
                ) : (
                    <>
                        <OfferPreviewPaymentToggle
                            text={props.copy.registerPrepayment}
                            active={props.registerPrepayment}
                            disabled={props.isSaving}
                            onClick={props.onRegisterPrepaymentToggle}
                        ></OfferPreviewPaymentToggle>
                        {isPartialPayment ? (
                            <FormBox>
                                <FormBoxTitle>
                                    <h4>{props.copy.prepaymentAmount}</h4>
                                </FormBoxTitle>
                                <Input_
                                    type="number"
                                    min="0.01"
                                    max={props.paymentTotal}
                                    step="0.01"
                                    required
                                    placeholder={props.copy.prepaymentAmount}
                                    value={props.partialAmount}
                                    onChange={props.onPartialAmountChange}
                                    disabled={props.isSaving}
                                ></Input_>
                                <OfferPreviewPaymentSummary>
                                    <div>
                                        <span>{props.copy.paymentTotal}</span>
                                        <strong>{format_payment_amount(props.paymentTotal, props.currency)}</strong>
                                    </div>
                                    <div>
                                        <span>{props.copy.paymentRemaining}</span>
                                        <strong>{format_payment_amount(props.paymentRemaining, props.currency)}</strong>
                                    </div>
                                </OfferPreviewPaymentSummary>
                            </FormBox>
                        ) : null}
                    </>
                )}
                {props.errorMessage ? <p>{props.errorMessage}</p> : null}
            </OfferPreviewPaidSliderContent>
        </Slider_>
    );
}
